<pbc-filter [config]="FelderFilterConfig" [filter]="felder.filter$ | async" (filterChange)="felder.filter$.next($event)"></pbc-filter>
